import { novoStatus } from './../extratos/exportacao-movimento/novoStatus'
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal'
import { AlertService } from '../common/alert/shared/alert.service'
import { Estabelecimento } from '../pkw-data/collect/estabelecimento/estabelecimento.model'
import { Situacao } from '../pkw-data/collect/estabelecimento/situacao.enum'
import { OperadoraDeMaquina } from '../pkw-data/collect/operadora-de-maquina.model'
import { Empresa } from '../pkw-data/core/empresa.model'
import { ListaPaginada, Pagina } from '../pkw-data/core/util/lista-paginada.model'
import { EstabelecimentoModalComponent } from './estabelecimento-modal/estabelecimento-modal.component'
import { OperadorasHomologadasModalComponent } from './operadoras-homologadas-modal/operadoras-homologadas-modal.component'
import { EstabelecimentoService } from './shared/estabelecimento.service'
import { EstabelecimentosRouteValues } from './shared/estabelecimentos.resolver'
import { FiltroEstabelecimento } from './shared/filtro-estabelecimento'
import { OperadorasIndisponiveisModalComponent } from './operadoras-indisponiveis-modal/operadoras-indisponiveis-modal.component'
import { OperadoraDeMaquinaService } from './../core/services/operadora-de-maquina.service'
import { ConfiguracaoExportacao } from './../extratos/exportacao-movimento/shared/configuracao-exportacao'
import { ExportacaoService } from './../extratos/exportacao-movimento/shared/exportacao.service'
import { Exportacao } from './../pkw-data/collect/exportacao.model'
import { Operador } from '../pkw-data/core/operador.model'
import { OperadorService } from '../core/services/operador.service'
import { DadosOperadoras } from './estabelecimento-modal/dados-operadoras'
import { environment } from '../../environments/environment'
import { SolicitacaoOperadoraModalComponent } from './solicitacao-operadora/solicitacao-operadora-modal/solicitacao-operadora-modal.component'

@Component({
    selector: 'col-estabelecimentos',
    templateUrl: './estabelecimentos.component.html',
    styleUrls: ['./estabelecimentos.component.scss'],
})
export class EstabelecimentosComponent implements OnInit {
    novostatus: any = {}

    todasOperadoras: OperadoraDeMaquina[]
    operadorasInativas: OperadoraDeMaquina[]
    empresasAtivas: Empresa[]
    estabelecimentos: ListaPaginada<Estabelecimento>
    filtro: FiltroEstabelecimento
    statusList: { situacao: Situacao; cssClass: string; desabilitado: boolean, ajuda?: string }[]
    possuiDados: boolean
    operadoras: OperadoraDeMaquina[]
    configuracao: ConfiguracaoExportacao
    exportacao: Exportacao
    nome: string
    nova_operadoras: boolean[] = []
    nomeOperadora: string[] = []
    novaOperadora: boolean
    operadora: number
    id: string[] = []
    operadoraNova: boolean[] = []
    aux: number
    isPopUpAvaAberto: boolean = false

    @ViewChild('confirmarExclusaoModal') confirmarExclusaoModal: ModalDirective
    @ViewChild('modalSincronizacao') modalsincronizacao: TemplateRef<any>

    private estabelecimentoExclusao: Estabelecimento
    private modalSincronizacaoRef: BsModalRef

    operador: Operador

    constructor(
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private estabelecimentoService: EstabelecimentoService,
        private alertService: AlertService,
        private operadoraDeMaquinaService: OperadoraDeMaquinaService,
        private exportacaoService: ExportacaoService,
        private operadorService: OperadorService
    ) {
        this.statusList = STATUS_LIST.filter((status) => !status.desabilitado)
        this.exportacao = this.exportacaoService.nova()
        this.configuracao = new ConfiguracaoExportacao(this.exportacao)
    }

    ngOnInit() {
        this.possuiDados = false

        this.route.data.subscribe(
            ({
                todasOperadoras,
                operadorasInativas,
                empresasAtivas,
                estabelecimentos,
            }) => {
                this.todasOperadoras = todasOperadoras.filter((e) => e.ativo)
                this.operadorasInativas = operadorasInativas
                this.empresasAtivas = empresasAtivas
                this.estabelecimentos = estabelecimentos.resultado
                this.filtro = estabelecimentos.filtro
                this.possuiDados = this.estabelecimentos.length > 0
            }
        )

        this.operadorService.corrente.subscribe((operador) => {
            this.operador = operador
        })

        this.operadoraDeMaquinaService.obterOperadoras().subscribe((operadoras) => {
            this.operadoras = operadoras
            this.configuracao.setOperadorasDisponiveis(operadoras)
            this.operadora = 0
            this.aux = 0
            for (let i = 0; i < this.operadoras.length; i++) {
                this.nome = this.operadoras[i].nome
                this.nova_operadoras[i] = this.operadoras[i].novaOperadora
                if (this.nova_operadoras[i] === true) {
                    this.operadora = this.operadora + 1
                    this.id[this.aux] = this.operadoras[i].id
                    this.nomeOperadora[this.aux] = this.nome
                    this.operadoraNova[this.aux] = this.nova_operadoras[i]
                    this.aux++
                }
            }
        })
        return
    }

    enviar(event) {
        event = this.novostatus
        this.atualizarDados(event)
        for (let i = 0; i < this.operadora; i++) {
            this.operadoraDeMaquinaService.atualizarNovaOperadora(event.id[i])
        }
    }

    private atualizarDados(operadoras: OperadoraDeMaquina) {
        const valores = this.novostatus
        valores.id = this.id
    }

    operadora_Nova() {
        return this.operadora > 0
    }

    filtrar(filtro: FiltroEstabelecimento) {
        this.filtro = filtro
        this.estabelecimentoService
            .pesquisar(this.filtro.toFilter())
            .subscribe((estabelecimentos) => {
                this.estabelecimentos = estabelecimentos
                this.possuiDados = estabelecimentos.length > 0
            })
    }

    paginar(indice: number, tamanho: number) {
        const pagina = new Pagina(indice, tamanho)

        this.estabelecimentoService
            .pesquisarPaginado(this.filtro.toFilter(), pagina)
            .subscribe(
                (listaEstabelecimentos) => (this.estabelecimentos = listaEstabelecimentos)
            )
    }

    cadastrar() {
        this.abrirEstabelecimentoModal().salvo.subscribe(() => {
            this.isPopUpAvaAberto = true
            this.alertService.success('Estabelecimento cadastrado com sucesso.', 'Aviso')
            this.filtrar(this.filtro)
        })
    }

    editar(estabelecimento: Estabelecimento) {
        this.estabelecimentoService
            .obter(estabelecimento.id)
            .subscribe((estabelecimentoAtualizado) => {
                this.abrirEstabelecimentoModal(estabelecimentoAtualizado).salvo.subscribe(
                    () => {
                        this.alertService.success(
                            'Estabelecimento atualizado com sucesso.',
                            'Aviso'
                        )
                        this.filtrar(this.filtro)
                    }
                )
            })
    }

    solicitarOperadora() {
        this.abrirSolicitacaoOperadoraModal().salvo.subscribe(() => {
            this.alertService.success('Solicitação enviada para análise com sucesso!', 'Aviso')
        })
    }

    obterContext(estabelecimento: Estabelecimento) {
        const status = STATUS_LIST.find((s) => s.situacao === estabelecimento.situacao)

        return status && status.cssClass
    }

    alternarSituacaoAtivo(estabelecimento: Estabelecimento) {
        if (
            estabelecimento.agente.operadoraDeMaquina &&
            DadosOperadoras.utilizaToken(estabelecimento.agente.operadoraDeMaquina) &&
            !estabelecimento.token
        ) {
            this.alertService.danger(
                'Estabelecimento sem token. Por favor, insira o token para realizar a ativação.'
            )
        } else {
            const eraAtivo = estabelecimento.ativo

            estabelecimento.situacao = eraAtivo ? Situacao.Inativo : Situacao.Ativo
            estabelecimento.save().subscribe(() => {
                this.alertService.success(
                    `Estabelecimento ${eraAtivo ? 'desativado' : 'ativado'} com sucesso.`,
                    'Aviso'
                )
            })
        }
    }

    obterIconeBtnAlternar(estabelecimento: Estabelecimento) {
        return estabelecimento.ativo || estabelecimento.situacao === 'Sincronizando'
            ? 'fa-toggle-on'
            : 'fa-toggle-off'
    }

    obterTooltipBtnAlternar(estabelecimento: Estabelecimento) {
        return estabelecimento.ativo
            ? 'Desativar estabelecimento'
            : 'Ativar estabelecimento'
    }

    validarExclusao(estabelecimento: Estabelecimento) {
        this.estabelecimentoExclusao = estabelecimento
        this.confirmarExclusaoModal.show()
    }

    confirmarExclusao() {
        this.confirmarExclusaoModal.hide()
        this.estabelecimentoService
            .excluir(this.estabelecimentoExclusao)
            .subscribe(() => {
                this.estabelecimentoExclusao = null
                this.alertService.success(
                    'Estabelecimento excluído com sucesso.',
                    'Aviso'
                )
                this.filtrar(this.filtro)
            })
    }

    recusarExclusao() {
        this.estabelecimentoExclusao = null
        this.confirmarExclusaoModal.hide()
    }

    exibirOperadoras() {
        this.operadoras = this.operadoras.filter((e) => e.ativo)

        this.modalService.show(OperadorasHomologadasModalComponent, {
            initialState: {
                operadoras: this.operadoras,
            },
        })
    }

    exibirOperadorasIndisponiveis() {
        this.modalService.show(OperadorasIndisponiveisModalComponent, {
            initialState: {
                operadoras: this.operadorasInativas,
            },
        })
    }

    abrirModalSincronizacao() {
        this.modalSincronizacaoRef = this.modalService.show(this.modalsincronizacao)
    }

    fecharModalSincronizacao() {
        this.modalSincronizacaoRef.hide()
    }

    private abrirEstabelecimentoModal(estabelecimento?: Estabelecimento) {
        const initialState = {
            operadoras: this.todasOperadoras,
            empresas: this.empresasAtivas,
            estabelecimento: estabelecimento,
            isEdicao: !!estabelecimento,
        }
        const modal = this.modalService.show(EstabelecimentoModalComponent, {
            initialState,
            backdrop: 'static',
            keyboard: false,
        })

        return modal.content as EstabelecimentoModalComponent
    }

    private abrirSolicitacaoOperadoraModal() {
        const modal = this.modalService.show(SolicitacaoOperadoraModalComponent, {
            initialState: {},
            backdrop: 'static',
            keyboard: false,
        })

        return modal.content as SolicitacaoOperadoraModalComponent
    }

    formatarNumeroEstabelecimento(cnpj) {
        while (cnpj && cnpj.toString().length >= 12 && cnpj.toString().length < 14) {
            cnpj = '0'.concat(cnpj)
        }
        return cnpj
    }

    desabilitarBotao(estabelecimento: Estabelecimento) {
        if (
            estabelecimento.agente.operadoraDeMaquina &&
            DadosOperadoras.utilizaToken(estabelecimento.agente.operadoraDeMaquina) &&
            !estabelecimento.token
        ) {
            return 'disabled'
        }
    }

    tipoUsuario() {
        return this.operador.isAdministrador() ||
            this.operador.isSuperAdministrador() === true
            ? true
            : false
    }

    collectPermissaoCriar() {
        return this.operador.UsaCollect().Criar === true ? true : false
    }

    collectPermissaoEditar() {
        return this.operador.UsaCollect().Editar === true ? true : false
    }

    collectPermissaoExcluir() {
        return this.operador.UsaCollect().Excluir === true ? true : false
    }

    fecharModalAva(event) {
        this.isPopUpAvaAberto = event
    }
}

export const STATUS_LIST = [
    { situacao: Situacao.Ativo, cssClass: 'context-color-green', desabilitado: false },
    { situacao: Situacao.Inativo, cssClass: 'context-color-orange', desabilitado: false },
    {
        situacao: Situacao.OperadoraForaDoAr,
        cssClass: 'context-color-violet',
        desabilitado: false,
    },
    {
        situacao: Situacao.VerificarSenha,
        cssClass: 'context-color-red',
        desabilitado: false,
    },
    {
        situacao: Situacao.ExigirAcaoUsuario,
        cssClass: 'context-color-blue', // 'context-color-blue',
        desabilitado: false,
    },
    {
        situacao: Situacao.BloqueioDuplaAutenticacao,
        cssClass: 'context-color-yellow',
        desabilitado: false,
        ajuda: environment.ajudaMFAGetNet
    },
    /**
     * TODO: Remover após estabilizar o novo collect na produção, permanecer até não existirem
     * estabelecimentos sincronizando na produção
     */
    {
        situacao: Situacao.Sincronizando,
        cssClass: 'context-color-green', // 'context-color-blue',
        desabilitado: true,
    },
]



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/estabelecimentos.component.ts